import { Component, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';

export interface ISidebarContentService {
  toggleSidebar();
  ensureSidebarIsOpen();
  ensureSidebarIsClosed();
}

@Injectable()
export class SidebarService {
  private isSidebarOpen: BehaviorSubject<Boolean>;

  constructor() {
    this.isSidebarOpen = new BehaviorSubject<Boolean>(false);
  }

  toggleSidebar(): void {
    document.querySelector('body').classList.toggle('active');
    this.isSidebarOpen.next(!this.isSidebarOpen.value);
  }

  // @todo improve naming of function
  onIsSidebarOpenChanged(): Observable<any> {
    return this.isSidebarOpen.asObservable();
  }

  ensureSidebarIsOpen() {
    if (!this.isSidebarOpen.value) {
      this.toggleSidebar();
    }
  }

  ensureSidebarIsClosed() {
    if (this.isSidebarOpen.value) {
      this.toggleSidebar();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sidebar.service.ts